import { OFetchRequestOptions, useOFetch } from '../../requests';
import { CustomFetchContext } from '../../requests/types';
import { ApiResponse } from '../../types';
import {
  Category,
  CourseBannerResponse,
  MockExamNavStatusResponse,
  DailyCheckInResponse,
  UserCenterCategory,
} from './types';

// 获取分类列表
export const getCategoryByCid = async (
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<Category>> => {
  return await useOFetch(
    '/subject/rk',
    {
      method: 'GET',
      ...options,
    },
    fetchContext
  );
};

// 获取用户中心分类列表
export const getUserCenterCategoryByCid = async (
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserCenterCategory[]>> => {
  return await useOFetch(
    '/pub/all-cate',
    {
      method: 'GET',
      ...options,
    },
    fetchContext
  );
};

// 获取app分类列表
export const getAppUserCenterCategoryByCid = async (
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserCenterCategory[]>> => {
  return await useOFetch(
    '/pub/some-cate',
    {
      method: 'GET',
      ...options,
    },
    fetchContext
  );
};

// 获取精品班 训练营 banner数据
export const getCourseBannerList = async (
  query?: { userSubject: string },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<CourseBannerResponse>> => {
  return await useOFetch(
    '/banner/index',
    {
      method: 'GET',
      ...options,
      query,
    },
    fetchContext
  );
};

// 控制模考大赛导航
export const getMockExamNavStatus = async (
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<MockExamNavStatusResponse>> => {
  return await useOFetch(
    '/banner/mokao',
    {
      method: 'GET',
      ...options,
    },
    fetchContext
  );
};

// 获取每日打卡的信息
export const getCheckIn = async (
  query = {},
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<DailyCheckInResponse>> => {
  return await useOFetch<DailyCheckInResponse>(
    `/practice/get-seven-day`,
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 试题重现显示逻辑
export const getQuestionReplay = async (
  query = {},
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<{ st: number; url: string }>> => {
  return await useOFetch(
    `/banner/estimate`,
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 知识点练习展示（特点科目id才展示）
export const getKnowledgeOpenCategoryIds = async (
  query = {},
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<number[]>> => {
  return await useOFetch(
    `/kpoint/open-category-ids`,
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};
